import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  InputGroup,
} from "react-bootstrap";
import "../../../common/FormPage/FormPage.css";
import Select from "react-select";
import Header from "../../../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { slugRules } from "../../../../utils/slug";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSave from "../../../common/ModelSave";
import { useNavigate } from "react-router";
import { putData } from "../../../../utils/api";
import JoditEditor from "jodit-react";
import { variant_type, SelectImageData } from "../../../../utils/common";
import DoubleVarient from "../DoubleVarient";
function Edit() {
  const { id } = useParams();

  const navigate = useNavigate();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
    getDimension,
  } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
    setValue,
    trigger,
    clearErrors,
  } = useForm({
    defaultValues: {
      dynamic_render: false,
      variants: [
        {
          name: "",
          price: "",
          mrp: "",
          image: "",
          description: "",
        },
      ],
    },
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [selectedTypes, setSelectedTypes] = useState([]);

  const handleCheckboxChange = (typeId, subTypeId, checked) => {
    setSelectedTypes((prev) => {
      const typeIndex = prev.findIndex((item) => item.type_id === typeId);
      const newSelected = [...prev];

      if (checked) {
        if (typeIndex !== -1) {
          // Type already exists, add subtype if not present
          if (!newSelected[typeIndex].sub_types.includes(subTypeId)) {
            newSelected[typeIndex].sub_types.push(subTypeId);
          }
        } else {
          // Add new type with this subtype
          newSelected.push({
            type_id: typeId,
            sub_types: [subTypeId],
          });
        }
      } else {
        // Uncheck
        if (typeIndex !== -1) {
          newSelected[typeIndex].sub_types = newSelected[
            typeIndex
          ].sub_types.filter((id) => id !== subTypeId);
          // Remove type entirely if no subtypes left
          if (newSelected[typeIndex].sub_types.length === 0) {
            newSelected.splice(typeIndex, 1);
          }
        }
      }
      return newSelected;
    });
  };

  const imageFiles = watch("images");

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();

      DataToSend.append("name", data?.name);
      DataToSend.append("description", data?.description);
      DataToSend.append("about_product", data?.about_product);
      DataToSend.append("meta_title", data?.meta_title);
      DataToSend.append("meta_description", data?.meta_description);
      DataToSend.append("keywords", data?.keywords);
      DataToSend.append("schema_data", data?.schema_data);
      DataToSend.append("order_ready_days", data?.order_ready_days);
      DataToSend.append("delivered", data?.delivered);
      DataToSend.append("ratings", data?.ratings);

      if (data?.p_category_id?.value) {
        DataToSend.append("p_category_id", data.p_category_id.value);
      }

      if (data?.p_sub_category_id?.value) {
        DataToSend.append("p_sub_category_id", data.p_sub_category_id.value);
      }

      if (data?.p_child_category_id?.value) {
        DataToSend.append(
          "p_child_category_id",
          data.p_child_category_id.value,
        );
      }

      if (data?.variant_type_id?.value) {
        DataToSend.append("variant_type_id", data.variant_type_id.value);
      }

      DataToSend.append("dynamic_render", data?.dynamic_render);
      DataToSend.append("orientation", data?.orientation);
      DataToSend.append("orientation_type", data?.orientation_type);
      DataToSend.append(
        "product_discount_status",
        data?.product_discount_status,
      );
      if (data?.product_discount_status) {
        DataToSend.append(
          "product_discount_percentage",
          data?.product_discount_percentage || 0,
        );
      }
      DataToSend.append("frame_status", data?.frame_status);

      if (data?.frame_status) {
        DataToSend.append("frame_count", data?.frame_count || 0);
      }
      DataToSend.append("quantity", data?.quantity);

      DataToSend.append("custom_status", data?.custom_status);
      // DataToSend.append("max_length", data?.max_length);
      // DataToSend.append("max_width", data?.max_width);
      if (data?.custom_status) {
        DataToSend.append("max_length", data?.max_length || 0);
        DataToSend.append("max_width", data?.max_width || 0);
      }

      // Thumbnail
      if (data.image?.[0]) {
        DataToSend.append("image", data.image[0]);
      }
      DataToSend.append("alt_tag", data?.alt_tag?.trim() || "");
      DataToSend.append("slug", data?.slug?.trim() || "");

      // Video
      if (data.video?.[0]) {
        DataToSend.append("video", data.video[0]);
      }

      // Gallery Images
      if (data?.images && data?.images.length > 0) {
        for (let i = 0; i < data.images.length; i++) {
          DataToSend.append("images", data.images[i]);
        }
      }

      // EJS
      if (data.dynamic_render && data.ejs?.[0]) {
        DataToSend.append("ejs", data.ejs[0]);
      }

      // Selected Types
      DataToSend.append("selected_types", JSON.stringify(selectedTypes));

      const response = await putData(`/admin/products/${id}`, DataToSend);

      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response.message,
        });

        setTimeout(() => {
          reset();
          navigate("/products");
        }, 1200);
      } else {
        setShowModal({
          code: response?.code || 400,
          message: response?.errors || "Failed to update product",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [Countries, setCountries] = useState([]);

  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [Farmer, setFarmer] = useState([]);
  const [DeliveryType, setDeliveryType] = useState([]);
  const [shapes, setShape] = useState([]);
  const watchedUnit = watch("unit_id");

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-p-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const getAllSubCategories = async (id) => {
    const response = await getData(`/common/masters/all-p-sub-category/${id}`);
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };
  const getAllChildCategories = async (id) => {
    const response = await getData(
      `/common/masters/all-vendor-p-child-categories/${id}`,
    );
    if (response?.success) {
      setChildCategories(
        await Select2Data(response?.data, "p_child_category_id"),
      );
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  const GetEditData = async () => {
    const response = await getData(`/admin/products/${id}`);

    if (response?.success) {
      reset(response?.data);

      // ====================== EJS / DOCUMENT PREVIEW ======================
      if (response?.data?.ejs) {
        const fileUrl = IMG_URL + response.data.ejs;
        const fileExt = response.data.ejs.split(".").pop().toLowerCase();

        // PDF
        if (fileExt === "pdf") {
          setDocumentPreview(fileUrl);
          setDocumentType("pdf");
        }

        // EJS / HTML
        else if (fileExt === "ejs" || fileExt === "html") {
          try {
            const fileResponse = await fetch(fileUrl);
            const htmlText = await fileResponse.text();

            setDocumentPreview(htmlText);
            setDocumentType("html");
          } catch (error) {
            console.error("Error loading EJS preview:", error);
          }
        }

        // Image fallback
        else {
          setImagePreview(fileUrl);
          setDocumentPreview(null);
          setDocumentType("");
        }
      }

      // Convert API response into selectedTypes format
      const formattedSelectedTypes = [];

      response?.data?.product_sub_types?.forEach((item) => {
        const typeId = item?.type_id?.value;
        const subTypeId = item?.sub_type_id?.value;

        const existingType = formattedSelectedTypes.find(
          (type) => type.type_id === typeId,
        );

        if (existingType) {
          existingType.sub_types.push(subTypeId);
        } else {
          formattedSelectedTypes.push({
            type_id: typeId,
            sub_types: [subTypeId],
          });
        }
      });

      setSelectedTypes(formattedSelectedTypes);

      // Load sub categories
      if (response?.data?.p_category_id?.value) {
        getAllSubCategories(response?.data?.p_category_id?.value);
      }

      if (response?.data?.p_sub_category_id?.value) {
        getAllChildCategories(response?.data?.p_sub_category_id?.value);
      }
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  // const [imagePreview, setImagePreview] = useState(null); // State to store image preview
  const [imagePreview, setImagePreview] = useState(null);
  const [documentPreview, setDocumentPreview] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [frameTypeSearch, setFrameTypeSearch] = useState({});

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      // PDF Preview
      if (file.type === "application/pdf") {
        const pdfURL = URL.createObjectURL(file);

        setDocumentPreview(pdfURL);
        setDocumentType("pdf");

        // Clear image preview
        setImagePreview(null);
        return;
      }

      // EJS / HTML Preview
      if (file.name.endsWith(".ejs") || file.name.endsWith(".html")) {
        const fileURL = URL.createObjectURL(file);

        setDocumentPreview(fileURL);
        setDocumentType("document");

        // Clear image preview
        setImagePreview(null);
        return;
      }

      // Image Preview
      const reader = new FileReader();

      reader.onloadend = () => {
        setImagePreview(reader.result);

        // Clear document preview
        setDocumentPreview(null);
        setDocumentType("");
      };

      reader.readAsDataURL(file);
    }
  };
  const [imagePreviews, setImagePreviews] = useState([]);

  const handleImagesChange = (e) => {
    const files = e.target.files;
    if (files) {
      const previews = [];
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push(reader.result);
          if (previews.length === files.length) {
            setImagePreviews(previews);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const [videoPreviews, setVideoPreview] = useState(null);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVideoPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [Metals, setMetal] = useState([]);
  const getAllType = async () => {
    const response = await getData(`/common/masters/all-type`);
    if (response?.success) {
      // setMetal(await Select2Data(response?.data, "type_id"));
      setMetal(response?.data);
    }
  };

  const [subType, setSubType] = useState([]);

  const getAllSubType = async (search = "") => {
    const response = await getData(
      `/common/masters/all-p-sub-type?term=${search}`,
    );

    if (response?.success) {
      setSubType(response?.data);
    }
  };

  const [VarientType, setVarientType] = useState([]);
  const getAllVarientType = async () => {
    const response = await getData(`/common/masters/all-variant-type`);
    if (response?.success) {
      setVarientType(await Select2Data(response?.data, "stock_type_id"));
    }
  };

  useEffect(() => {
    getAllVarientType();
    getAllType();

    getAllSubType();
  }, []);

  const [GalleryImages, setGalleryImages] = useState([]);
  const getGalleyImages = async () => {
    try {
      const response = await getData("/common/masters/all-gallery-images");

      // Check if response and response.data exist
      if (response && response.data) {
        setGalleryImages(await SelectImageData(response.data, "image"));
      } else {
        console.error("No gallery images data found:", response);
      }
    } catch (error) {
      console.error("Error fetching gallery images:", error);
    }
  };

  useEffect(() => {
    getGalleyImages();
  }, []);

  const handleGalleryImageChange = (selectedOption) => {
    // Reset the file input when an image is selected from the gallery
    setValue("ejs", null); // Reset file input
    setValue("gallery_image", selectedOption); // Set the gallery image in the form
    setImagePreview(IMG_URL + selectedOption?.ejs); // Set the selected image preview
    clearErrors();
  };

  // const handleFileInputChange = (e) => {
  //   // Reset the dropdown when a file is uploaded
  //   setValue("gallery_image", null); // Reset gallery selection
  //   handleImageChange(e); // Handle the file input change
  //   clearErrors();
  // };
  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setValue("gallery_image", null);
    clearErrors();

    if (file.type === "application/pdf") {
      const pdfURL = URL.createObjectURL(file);
      setDocumentPreview(pdfURL);
      setDocumentType("pdf");
      return;
    }

    // For .ejs or .html → Read as text
    if (file.name.endsWith(".ejs") || file.name.endsWith(".html")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDocumentPreview(reader.result); // This is raw HTML string
        setDocumentType("html");
      };
      reader.readAsText(file);
      return;
    }

    // Fallback for images
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <>
      <Header title={"Edit Product"} link={"/employee/employee_details"} />
      <section className="Create">
        {/* back button start */}
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/products`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {/* back button end */}

        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* 1. Order Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>1. Product Category</h6>
            </div>
            <div className="package-details-section">
              <div className="pending-table ">
                <div className="row ">
                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={categories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllSubCategories(selectedValue?.value);
                            setValue("p_sub_category_id", "");
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_category_id && (
                      <span className="text-danger">
                        {errors.p_category_id.message}
                      </span>
                    )}
                  </div>

                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Sub Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_sub_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Sub Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_sub_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={subCategories}
                          // onChange={(selectedValue) => {
                          //   onChange(selectedValue);
                          // }}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);

                            setValue("p_child_category_id", null); // clear previous child category
                            getAllChildCategories(selectedValue?.value);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_sub_category_id && (
                      <span className="text-danger">
                        {errors.p_sub_category_id.message}
                      </span>
                    )}
                  </div>

                  <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-2 col-12 mb-2">
                    <Form.Label>Child Category</Form.Label>

                    <Controller
                      name="p_child_category_id"
                      control={control}
                      rules={{
                        required: "Select Child Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_child_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          options={childCategories}
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />

                    {errors.p_child_category_id && (
                      <span className="text-danger">
                        {errors.p_child_category_id.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 2. Package Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>2. Product</h6>
            </div>
            <div className="package-details-section">
              <Row className="new-row">
                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Name</div>
                    </Col>
                    <Col lg={8} md={6}>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="text"
                          name={`name`}
                          placeholder="name"
                          className={classNames("", {
                            "is-invalid": errors?.name, // Adjusted error checking
                          })}
                          {...register(`name`, {
                            required: "name is required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </div>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Slug</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <Form.Control
                        type="text"
                        name="slug"
                        placeholder="e.g. wooden-frame"
                        className={classNames("", {
                          "is-invalid": errors?.slug,
                        })}
                        {...register("slug", slugRules)}
                      />
                      {errors.slug && (
                        <span className="text-danger">
                          {errors.slug.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  {/* Package Weight */}

                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Description</div>
                    </Col>

                    <Col lg={8} md={4}>
                      <div>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name="description"
                          placeholder="Description"
                          className={classNames({
                            "is-invalid": errors?.description,
                          })}
                          {...register("description", {
                            required: "Description is required",
                            validate: (value) => {
                              const words = value.match(/\b\w+\b/g);

                              return (
                                !words ||
                                words.length <= 100 ||
                                "Data must be 100 words or less"
                              );
                            },
                          })}
                        />
                      </div>

                      {errors.description && (
                        <span className="text-danger">
                          {errors.description.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Product Quantity</div>
                    </Col>

                    <Col lg={8} md={4}>
                      <div>
                        <Form.Control
                          type="text"
                          name="quantity"
                          placeholder="Product Quantity"
                          className={classNames({
                            "is-invalid": errors?.quantity,
                          })}
                          {...register("quantity", {
                            required: "Product Quantity is required",
                            validate: (value) => {
                              const number = Number(value);

                              if (isNaN(number)) {
                                return "Only numbers are allowed";
                              }

                              if (number <= 0) {
                                return "Product Quantity must be greater than 0";
                              }

                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            // Allow control keys
                            if (
                              e.key === "Backspace" ||
                              e.key === "Delete" ||
                              e.key === "Tab" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight"
                            ) {
                              return;
                            }

                            // Allow only digits
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                              return;
                            }

                            const currentValue = e.target.value;
                            const nextValue = currentValue + e.key;

                            // Prevent 0 as the first value
                            if (Number(nextValue) <= 0) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>

                      {errors.quantity && (
                        <span className="text-danger">
                          {errors.quantity.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Order Ready Days</div>
                    </Col>

                    <Col lg={8} md={4}>
                      <div>
                        <Form.Control
                          type="text"
                          name="order_ready_days"
                          placeholder="Order Ready Days"
                          className={classNames({
                            "is-invalid": errors?.order_ready_days,
                          })}
                          {...register("order_ready_days", {
                            required: "Order Ready Days is required",
                            validate: (value) => {
                              const number = Number(value);

                              if (isNaN(number)) {
                                return "Only numbers are allowed";
                              }

                              if (number <= 0 || number > 100) {
                                return "Order Ready Days must be between 1 and 100";
                              }

                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            // Allow control keys
                            if (
                              e.key === "Backspace" ||
                              e.key === "Delete" ||
                              e.key === "Tab" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight"
                            ) {
                              return;
                            }

                            // Allow only digits
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                              return;
                            }

                            const currentValue = e.target.value;
                            const nextValue = currentValue + e.key;

                            // Prevent 0 and values greater than 100
                            if (
                              Number(nextValue) <= 0 ||
                              Number(nextValue) > 100
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>

                      {errors.order_ready_days && (
                        <span className="text-danger">
                          {errors.order_ready_days.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Delivered Day</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <div>
                        <Form.Control
                          type="text"
                          name="delivered"
                          placeholder="Delivered Day"
                          className={classNames({
                            "is-invalid": errors?.delivered,
                          })}
                          {...register("delivered", {
                            required: "Delivered Day is required",
                            validate: (value) => {
                              const number = Number(value);

                              if (isNaN(number)) {
                                return "Only numbers are allowed";
                              }

                              if (number <= 0 || number > 100) {
                                return "Delivered Day must be between 1 and 100";
                              }

                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            // Allow control keys
                            if (
                              e.key === "Backspace" ||
                              e.key === "Delete" ||
                              e.key === "Tab" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight"
                            ) {
                              return;
                            }

                            // Allow only digits
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                              return;
                            }

                            const currentValue = e.target.value;
                            const nextValue = currentValue + e.key;

                            // Prevent 0 and values greater than 100
                            if (
                              Number(nextValue) <= 0 ||
                              Number(nextValue) > 100
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>

                      {errors.delivered && (
                        <span className="text-danger">
                          {errors.delivered.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Rating (1 - 5)</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          placeholder="Enter ratings"
                          className={classNames({
                            "is-invalid": errors?.ratings,
                          })}
                          {...register("ratings", {
                            required: "Rating is required",
                            valueAsNumber: true,
                            min: { value: 1, message: "Minimum rating is 1" },
                            max: { value: 5, message: "Maximum rating is 5" },
                          })}
                        />
                      </InputGroup>

                      {errors.ratings && (
                        <span className="text-danger">
                          {errors.ratings.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">About Product</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <InputGroup>
                        <Controller
                          name="about_product"
                          control={control}
                          rules={{
                            required: "About Product is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("about_product");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                      </InputGroup>

                      {errors.about_product && (
                        <span className="text-danger">
                          {errors.about_product.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Meta Title</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Meta Title"
                          className={classNames("", {
                            "is-invalid": errors?.meta_title,
                          })}
                          {...register("meta_title", {
                            required: "Meta title is required",
                          })}
                        />
                      </InputGroup>
                      {errors.meta_title && (
                        <span className="text-danger">
                          {errors.meta_title.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Meta Description</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Meta Description"
                          className={classNames("", {
                            "is-invalid": errors?.meta_description,
                          })}
                          {...register("meta_description", {
                            required: "Meta Description is required",
                          })}
                        />
                      </InputGroup>
                      {errors.meta_description && (
                        <span className="text-danger">
                          {errors.meta_description.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Meta Keywords</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Meta Keywords"
                          className={classNames("", {
                            "is-invalid": errors?.keywords,
                          })}
                          {...register("keywords", {
                            required: "Meta Keywords is required",
                          })}
                        />
                      </InputGroup>
                      {errors.keywords && (
                        <span className="text-danger">
                          {errors.keywords.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Schema Data</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <InputGroup>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          placeholder="Schema Data"
                          className={classNames("", {
                            "is-invalid": errors?.schema_data,
                          })}
                          {...register("schema_data", {
                            required: "Schema Data is required",
                          })}
                        />
                      </InputGroup>
                      {errors.schema_data && (
                        <span className="text-danger">
                          {errors.schema_data.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}></Col>
                <Col md={6}>
                  {/* Orientation & Dynamic Render */}
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Orientation</div>
                    </Col>
                    <Col lg={4} md={4}>
                      <Controller
                        name="orientation"
                        control={control}
                        defaultValue={true}
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            label={field.value ? "Enabled" : "Disabled"}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Orientation Type</div>
                    </Col>

                    <Col lg={8} md={4}>
                      <Controller
                        name="orientation_type"
                        control={control}
                        defaultValue="horizontal"
                        render={({ field }) => (
                          <div className="d-flex gap-3">
                            <Form.Check
                              type="radio"
                              label="Horizontal"
                              checked={field.value === "horizontal"}
                              onChange={() => field.onChange("horizontal")}
                            />

                            <Form.Check
                              type="radio"
                              label="Vertical"
                              checked={field.value === "vertical"}
                              onChange={() => field.onChange("vertical")}
                            />
                          </div>
                        )}
                      />

                      {errors.orientation_type && (
                        <span className="text-danger">
                          {errors.orientation_type.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">
                        Product Discount Status
                      </div>
                    </Col>
                    <Col lg={8} md={4}>
                      <Controller
                        name="product_discount_status"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            label={field.value ? "Enabled" : "Disabled"}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  {watch("product_discount_status") && (
                    <>
                      <Row className="detail-row">
                        <Col md={4}>
                          <div className="detail-label">
                            Product Discount Percentage
                          </div>
                        </Col>
                        <Col lg={4} md={4}>
                          <Form.Control
                            type="text"
                            name="product_discount_percentage"
                            placeholder="Enter Discount Percentage"
                            className={classNames("", {
                              "is-invalid": errors?.product_discount_percentage,
                            })}
                            {...register("product_discount_percentage", {
                              required: "Discount percentage is required",
                              validate: (value) => {
                                const number = Number(value);

                                if (isNaN(number)) {
                                  return "Only numbers are allowed";
                                }

                                if (number < 0 || number > 100) {
                                  return "Discount percentage must be between 0 and 100";
                                }

                                return true;
                              },
                            })}
                            onKeyDown={(e) => {
                              // Allow control keys
                              if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight"
                              ) {
                                return;
                              }

                              // Allow only digits
                              if (!/^\d$/.test(e.key)) {
                                e.preventDefault();
                                return;
                              }

                              // Prevent values greater than 100
                              const currentValue = e.target.value;
                              const nextValue = currentValue + e.key;

                              if (Number(nextValue) > 100) {
                                e.preventDefault();
                              }
                            }}
                          />

                          {errors.product_discount_percentage && (
                            <span className="text-danger">
                              {errors.product_discount_percentage.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Frame Status</div>
                    </Col>
                    <Col lg={8} md={4}>
                      <Controller
                        name="frame_status"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            label={field.value ? "Enabled" : "Disabled"}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  {watch("frame_status") && (
                    <>
                      <Row className="detail-row">
                        <Col md={4}>
                          <div className="detail-label">
                            Frame Count (1 - 100)
                          </div>
                        </Col>
                        <Col lg={8} md={4}>
                          <Form.Control
                            type="text"
                            name="frame_count"
                            placeholder="Frame Count"
                            className={classNames("", {
                              "is-invalid": errors?.frame_count,
                            })}
                            {...register("frame_count", {
                              required: "Frame Count is required",
                              validate: (value) => {
                                const number = Number(value);

                                if (isNaN(number)) {
                                  return "Only numbers are allowed";
                                }

                                if (number <= 0 || number > 100) {
                                  return "Frame Count must be between 1 and 100";
                                }

                                return true;
                              },
                            })}
                            onKeyDown={(e) => {
                              // Allow control keys
                              if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight"
                              ) {
                                return;
                              }

                              // Allow only digits
                              if (!/^\d$/.test(e.key)) {
                                e.preventDefault();
                                return;
                              }

                              const currentValue = e.target.value;
                              const nextValue = currentValue + e.key;

                              // Prevent 0 and values greater than 100
                              if (
                                Number(nextValue) <= 0 ||
                                Number(nextValue) > 100
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {errors.frame_count && (
                            <span className="text-danger">
                              {errors.frame_count.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Custom Status</div>
                    </Col>
                    <Col lg={4} md={4}>
                      <Controller
                        name="custom_status"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            label={field.value ? "Enabled" : "Disabled"}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  {watch("custom_status") && (
                    <>
                      <Row className="detail-row">
                        <Col md={4}>
                          <div className="detail-label">Max Length</div>
                        </Col>
                        <Col lg={8} md={4}>
                          <Form.Control
                            type="text"
                            name="max_length"
                            placeholder="Enter Max Length"
                            className={classNames("", {
                              "is-invalid": errors?.max_length,
                            })}
                            {...register("max_length", {
                              required: "Max Length is required",
                              validate: (value) => {
                                const number = Number(value);

                                if (isNaN(number)) {
                                  return "Only numbers are allowed";
                                }

                                if (number <= 0 || number > 100) {
                                  return "Value must be between 1 and 100";
                                }

                                return true;
                              },
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight"
                              ) {
                                return;
                              }

                              // Allow only digits 0-9
                              if (!/^\d$/.test(e.key)) {
                                e.preventDefault();
                                return;
                              }

                              const currentValue = e.target.value;
                              const nextValue = currentValue + e.key;

                              // Prevent 0 and values greater than 100
                              if (
                                Number(nextValue) <= 0 ||
                                Number(nextValue) > 100
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />

                          {errors.max_length && (
                            <span className="text-danger">
                              {errors.max_length.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row className="detail-row">
                        <Col md={4}>
                          <div className="detail-label">Max Width</div>
                        </Col>
                        <Col lg={4} md={4}>
                          <Form.Control
                            type="text"
                            name="max_width"
                            placeholder="Enter Max Width"
                            className={classNames("", {
                              "is-invalid": errors?.max_width,
                            })}
                            {...register("max_width", {
                              required: "Max Width is required",
                              validate: (value) => {
                                const number = Number(value);

                                if (isNaN(number)) {
                                  return "Only numbers are allowed";
                                }

                                if (number <= 0 || number > 100) {
                                  return "Value must be between 1 and 100";
                                }

                                return true;
                              },
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight"
                              ) {
                                return;
                              }

                              // Allow only digits 0-9
                              if (!/^\d$/.test(e.key)) {
                                e.preventDefault();
                                return;
                              }

                              const currentValue = e.target.value;
                              const nextValue = currentValue + e.key;

                              // Prevent 0 and values greater than 100
                              if (
                                Number(nextValue) <= 0 ||
                                Number(nextValue) > 100
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />

                          {errors.max_width && (
                            <span className="text-danger">
                              {errors.max_width.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={4}>
                      <div className="detail-label">Dynamic Render</div>
                    </Col>
                    <Col lg={4} md={4}>
                      <Controller
                        name="dynamic_render"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            label={field.value ? "Enabled" : "Disabled"}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  {watch("dynamic_render") && (
                    <>
                      <Row className="detail-row">
                        <Col md={4}>
                          <div className="detail-label">
                            EJS / HTML File Upload
                          </div>
                        </Col>
                        <Col lg={4} md={4}>
                          <Form.Control
                            type="file"
                            {...register("ejs", {
                              validate: {
                                fileType: (value) => {
                                  // No file selected
                                  if (!value || value.length === 0) return true;

                                  // Existing file from backend (string)
                                  if (typeof value === "string") return true;

                                  // File object exists
                                  const file = value?.[0];

                                  if (!file || !file.name) return true;

                                  const fileName = file.name.toLowerCase();

                                  return (
                                    fileName.endsWith(".ejs") ||
                                    fileName.endsWith(".html") ||
                                    fileName.endsWith(".pdf") ||
                                    "Only .ejs, .html, and .pdf files allowed"
                                  );
                                },
                              },
                            })}
                            accept=".ejs,.html,.pdf"
                            onChange={handleFileInputChange}
                          />
                          {errors.ejs && (
                            <span className="text-danger">
                              {errors.ejs.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>

                <Col md={6}>
                  <Row className="detail-row">
                    <Col md={6}>
                      <div className="detail-label">
                        Thumbnail Upload image (928 × 945 px).
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="file"
                          name="image"
                          accept="image/*, video/*"
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          {...register("image", {})}
                          onChange={handleImageChange}
                        />
                      </div>

                      {errors.image && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )}
                      <Form.Control
                        type="text"
                        name="alt_tag"
                        placeholder="Alt Tag"
                        className="mt-2"
                        {...register("alt_tag")}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  {typeof getValues("image") === "string" ? (
                    // If image is a string (URL), show the preview
                    <div className="image-preview-container ms-5">
                      {getValues("image").endsWith(".mp4") ||
                      getValues("image").endsWith(".mov") ||
                      getValues("image").endsWith(".avi") ? (
                        // If the file is a video, show a video element
                        <video
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="preview-video"
                          // controls
                          autoPlay
                          muted
                          loop
                        >
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // If it's an image, show the image preview
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          width={50}
                        />
                      )}
                    </div>
                  ) : (
                    // If the image is not a string (i.e., it's a file or URL in preview), show that
                    imagePreview && (
                      <div className="image-preview-container ms-5">
                        {imagePreview.includes("video") ? (
                          // If the preview is a video, show a video element
                          <video
                            src={imagePreview}
                            alt="Preview"
                            className="preview-video"
                            // controls
                            autoPlay
                            muted
                            loop
                          >
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          // Otherwise, show an image
                          <img
                            src={imagePreview}
                            alt="Category Preview"
                            width={150}
                          />
                        )}
                      </div>
                    )
                  )}

                  {typeof getValues("video") === "string" ? (
                    // If image is a string (URL), show the preview
                    <div className="image-preview-container ms-5">
                      {getValues("video").endsWith(".mp4") ||
                      getValues("video").endsWith(".mov") ||
                      getValues("video").endsWith(".avi") ? (
                        // If the file is a video, show a video element
                        <video
                          src={IMG_URL + getValues("video")}
                          alt="Preview"
                          className="preview-video"
                          // controls
                          autoPlay
                          muted
                          loop
                          width={100}
                        >
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // If it's an image, show the image preview
                        <img
                          src={IMG_URL + getValues("video")}
                          alt="Preview"
                          className="image-preview"
                          width={50}
                        />
                      )}
                    </div>
                  ) : (
                    // If the image is not a string (i.e., it's a file or URL in preview), show that
                    videoPreviews && (
                      <div className="image-preview-container ms-5">
                        {videoPreviews.includes("video") ? (
                          // If the preview is a video, show a video element
                          <video
                            src={videoPreviews}
                            alt="Preview"
                            className="preview-video"
                            // controls
                            autoPlay
                            muted
                            loop
                            width={100}
                          >
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          // Otherwise, show an image
                          <img
                            src={videoPreviews}
                            alt="Category Preview"
                            width={150}
                          />
                        )}
                      </div>
                    )
                  )}
                </Col>
              </Row>

              {/* <Row className="detail-row">
                    <Col md={6}>
                      <div className="detail-label">Video</div>
                    </Col>

                    <Col lg={6} md={6}>
                      <Form.Control
                        type="file"
                        accept="video/mp4"
                        className={classNames({
                          "is-invalid": errors?.video,
                        })}
                        {...register("video", {
                          validate: (value) => {
                            // Edit case (string from backend)
                            if (typeof value === "string") return true;

                            // New upload case
                            if (value && value[0]) {
                              const file = value[0];
                              const allowedTypes = ["mp4"];
                              const ext = file.name
                                .split(".")
                                .pop()
                                .toLowerCase();

                              if (!allowedTypes.includes(ext)) {
                                return "Only MP4 video is allowed";
                              }
                            }
                            return true;
                          },
                        })}
                        onChange={(e) => {
                          handleVideoChange(e); // preview logic
                        }}
                      />

                      {errors?.video && (
                        <span className="text-danger">
                          {errors.video.message}
                        </span>
                      )}
                    </Col>
                  </Row> */}
            </div>
          </div>
          {/* 2. Package Details end */}

          {/* 3. Pickup Slot Details end */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>3. Images Upload image (928 × 945 px).</h6>
            </div>
            <div className="package-details-section">
              {/* Pickup Slot */}
              <Row className="detail-row">
                <Col lg={4} md={4}>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="file"
                      name="images"
                      multiple
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.images,
                      })}
                      {...register("images", {
                        // required: "Images is required",
                      })}
                      accept="image/*"
                      onChange={handleImagesChange}
                    />
                  </div>
                  {errors.images && (
                    <span className="text-danger">{errors.images.message}</span>
                  )}
                </Col>
                {/* {imagePreviews && imagePreviews.map((image, index) => {
                  return (
                    <div className="mt-2" key={index}>
                      <img
                        src={image}
                        alt={`Category Preview ${index}`}
                        style={{ maxWidth: "100px" }}
                      />
                    </div>
                  );
                })} */}

                {imagePreviews && imagePreviews.length > 0 ? (
                  <div className=" mt-2">
                    {imagePreviews.map((image, index) => {
                      return (
                        <img
                          src={image}
                          alt={`Preview ${index + 1}`}
                          className="ms-2"
                          width={100}
                        />
                      );
                    })}
                  </div>
                ) : (
                  Array.isArray(imageFiles) &&
                  imageFiles.length > 0 && (
                    <div className=" mt-2">
                      {/* Displaying image URLs from the API response */}
                      {imageFiles.map((imageObj, index) => {
                        // Ensure the object has an 'image' URL property
                        if (imageObj && imageObj.image) {
                          return (
                            <img
                              src={IMG_URL + imageObj.image} // Use image URL from API response
                              alt={`Preview ${index + 1}`}
                              className=" ms-2"
                              width={100}
                            />
                          );
                        }
                        return null; // Skip rendering if the image URL is not present
                      })}
                    </div>
                  )
                )}
              </Row>
            </div>
          </div>

          {/* 4. Types and Sub Types */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>4. Types and Sub Types</h6>
            </div>
            <div className="package-details-section">
              <Row>
                {/* <Col lg={12}>
                  {Metals && Metals.length > 0 ? (
                    Metals.map((type) => {
                      const subtypes = subType.filter(
                        (sub) => sub.type_id === type.id,
                      );
                      return (
                        <div key={type.id} className="mb-4 border-bottom pb-3">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-0">{type.name} :</h6>

                            <Form.Control
                              type="text"
                              placeholder="Search Frame Type..."
                              style={{ width: "250px" }}
                              value={frameTypeSearch[type.id] || ""}
                              onChange={(e) =>
                                setFrameTypeSearch((prev) => ({
                                  ...prev,
                                  [type.id]: e.target.value,
                                }))
                              }
                            />
                          </div>

                          {subtypes.length > 0 ? (
                            <div className="row g-3">
                              {subtypes
                                .filter((subtype) => {
                                  const search = (
                                    frameTypeSearch[type.id] || ""
                                  ).toLowerCase();

                                  return (
                                    subtype.name
                                      ?.toLowerCase()
                                      .includes(search) ||
                                    subtype.Frame_Type?.name
                                      ?.toLowerCase()
                                      .includes(search)
                                  );
                                })
                                .map((subtype) => (
                                  <Col key={subtype.id} lg={3} md={4} sm={6}>
                                    <div className="subtype-card p-3 border rounded h-100 shadow-sm">
                            
                                      <Form.Check
                                        type="checkbox"
                                        id={`subtype-${subtype.id}`}
                                        label={
                                          <span className="fw-bold">
                                            {subtype.name}
                                          </span>
                                        }
                                        checked={selectedTypes.some(
                                          (item) =>
                                            item.type_id === type.id &&
                                            item.sub_types.includes(subtype.id),
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            type.id,
                                            subtype.id,
                                            e.target.checked,
                                          )
                                        }
                                      />

                                      <div className="small text-muted ms-4 mt-2">
                                        {subtype.Frame_Type?.name && (
                                          <div className="mb-1">
                                            <strong>Frame Type:</strong>{" "}
                                            {subtype.Frame_Type.name}
                                          </div>
                                        )}

                                        <div className="mb-1">
                                          <strong>Size:</strong>{" "}
                                          {subtype.length} × {subtype.width}
                                        </div>

                                        <div className="mb-1">
                                          <strong>Per Sq Ft Price:</strong> ₹
                                          {subtype.per_sq_ft_price}
                                        </div>

                                        {subtype.description && (
                                          <div className="mb-2">
                                            <strong>Description:</strong>
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: subtype.description,
                                              }}
                                            />
                                          </div>
                                        )}

                                        {subtype.image && (
                                          <div className="mb-2">
                                            <strong>Image:</strong>
                                            <br />
                                            <img
                                              src={IMG_URL + subtype.image}
                                              alt={subtype.name}
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                                borderRadius: "6px",
                                                border: "1px solid #ddd",
                                              }}
                                            />
                                          </div>
                                        )}

                                        {subtype.border_image && (
                                          <div className="mb-2">
                                            <strong>Border Image:</strong>
                                            <br />
                                            <img
                                              src={
                                                IMG_URL + subtype.border_image
                                              }
                                              alt="Border"
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                                borderRadius: "6px",
                                                border: "1px solid #ddd",
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                ))}
                            </div>
                          ) : (
                            <p className="text-muted fst-italic ms-3">
                              No subtypes available.
                            </p>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p>No types available.</p>
                  )}
                </Col> */}
                <Col lg={12}>
                  {Metals?.length > 0 ? (
                    Metals.map((type) => {
                      // Type wise subtypes
                      const filteredSubTypes = subType.filter(
                        (item) => Number(item?.type_id) === Number(type?.id),
                      );

                      return (
                        <div key={type.id} className="mb-4 border-bottom pb-3">
                          {/* Type Name */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0 fw-bold">{type.name}</h5>

                            <Form.Control
                              type="text"
                              placeholder={`Search ${type.name}`}
                              style={{ width: "250px" }}
                              value={frameTypeSearch[type.id] || ""}
                              onChange={(e) =>
                                setFrameTypeSearch((prev) => ({
                                  ...prev,
                                  [type.id]: e.target.value,
                                }))
                              }
                            />
                          </div>

                          {/* Sub Types */}
                          {filteredSubTypes?.length > 0 ? (
                            <Row className="g-3">
                              {filteredSubTypes
                                .filter((subtype) => {
                                  const search = (
                                    frameTypeSearch[type.id] || ""
                                  ).toLowerCase();

                                  return (
                                    subtype?.name
                                      ?.toLowerCase()
                                      .includes(search) ||
                                    subtype?.Frame_Type?.name
                                      ?.toLowerCase()
                                      .includes(search)
                                  );
                                })
                                .map((subtype) => (
                                  <Col key={subtype.id} lg={3} md={4} sm={6}>
                                    <div className="subtype-card p-3 border rounded shadow-sm h-100">
                                      {/* Checkbox */}
                                      <Form.Check
                                        type="checkbox"
                                        id={`subtype-${subtype.id}`}
                                        label={
                                          <span className="fw-bold">
                                            {subtype.name}
                                          </span>
                                        }
                                        checked={selectedTypes.some(
                                          (item) =>
                                            Number(item.type_id) ===
                                              Number(type.id) &&
                                            item.sub_types.includes(subtype.id),
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            type.id,
                                            subtype.id,
                                            e.target.checked,
                                          )
                                        }
                                      />

                                      <div className="small text-muted ms-4 mt-2">
                                        {/* Frame Type */}
                                        {subtype.Frame_Type?.name && (
                                          <div className="mb-1">
                                            <strong>Frame Type:</strong>{" "}
                                            {subtype.Frame_Type.name}
                                          </div>
                                        )}

                                        {/* Show Size ONLY for Frame Size */}
                                        {type.name === "Frame Size" && (
                                          <div className="mb-1">
                                            <strong>Size:</strong>{" "}
                                            {subtype.length} × {subtype.width}
                                          </div>
                                        )}

                                        {/* Show Thickness + Count ONLY for Mount Type */}
                                        {type.name === "Mount Type" && (
                                          <>
                                            <div className="mb-1">
                                              <strong>Min Thickness:</strong>{" "}
                                              {subtype.min_thickness || 0}
                                            </div>

                                            <div className="mb-1">
                                              <strong>Max Thickness:</strong>{" "}
                                              {subtype.max_thickness || 0}
                                            </div>

                                            <div className="mb-1">
                                              <strong>Count:</strong>{" "}
                                              {subtype.count || 0}
                                            </div>
                                          </>
                                        )}

                                        {/* Price */}
                                        <div className="mb-1">
                                          <strong>Per Sq Ft Price:</strong> ₹
                                          {subtype.per_sq_ft_price}
                                        </div>

                                        {/* Description */}
                                        {subtype.description && (
                                          <div className="mb-2">
                                            <strong>Description:</strong>

                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: subtype.description,
                                              }}
                                            />
                                          </div>
                                        )}

                                        {/* Main Image */}
                                        {subtype.image && (
                                          <div className="mb-2">
                                            <strong>Image:</strong>
                                            <br />

                                            <img
                                              src={IMG_URL + subtype.image}
                                              alt={subtype.name}
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                                borderRadius: "6px",
                                                border: "1px solid #ddd",
                                              }}
                                            />
                                          </div>
                                        )}

                                        {/* Border Image */}
                                        {subtype.border_image && (
                                          <div className="mb-2">
                                            <strong>Border Image:</strong>
                                            <br />

                                            <img
                                              src={
                                                IMG_URL + subtype.border_image
                                              }
                                              alt="Border"
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                                borderRadius: "6px",
                                                border: "1px solid #ddd",
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                ))}
                            </Row>
                          ) : (
                            <p className="text-muted fst-italic">
                              No sub types available
                            </p>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p>No types available.</p>
                  )}
                </Col>
              </Row>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="text-center mt-4 mx-2">
              <button
                className="Back-button"
                type="button"
                onClick={() => navigate("/products")}
              >
                Cancel
              </button>
            </div>

            <div className="text-center mt-4 mx-2">
              <button className="schedule-button" type="submit">
                Update Product
              </button>
            </div>
          </div>
        </Form>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
